import type { useFooterModel } from '@/components/shared/footer/footer.model'

type FooterViewProps = ReturnType<typeof useFooterModel>

export function FooterView({
  storeInfo,
  developerCredits,
  navigationLinks,
  contactEmail,
  contactEmailHref,
  deliveryLine,
  currentYear,
}: FooterViewProps) {
  return (
    <footer className="fz-footer">
      <div className="fz-footer__grid">
        <div className="fz-footer__brand">
          <div className="fz-footer__wordmark-group">
            <span className="fz-footer__wordmark-eyebrow">
              Floricultura-ateliê
            </span>
            <span className="fz-footer__wordmark">Flora Ateliê</span>
          </div>
          <p className="fz-footer__slogan">{storeInfo.slogan}</p>
        </div>
        <nav className="fz-footer__nav" aria-label="Categorias e páginas">
          <span className="fz-footer__heading">Navegação</span>
          <ul className="fz-footer__nav-list">
            {navigationLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} className="fz-footer__nav-link">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="fz-footer__contact">
          <span className="fz-footer__heading">Contato</span>
          <a href={contactEmailHref} className="fz-footer__contact-link">
            {contactEmail}
          </a>
          <span className="fz-footer__contact-text">{deliveryLine}</span>
          <span className="fz-footer__contact-text">
            {storeInfo.hoursWeekdays} · {storeInfo.hoursSunday}
          </span>
        </div>
      </div>
      <div className="fz-footer__bottom">
        <a
          href={developerCredits.url}
          target="_blank"
          rel="noopener noreferrer"
          className="fz-footer__credits"
        >
          Desenvolvido por {developerCredits.name} © {currentYear}
        </a>
      </div>
    </footer>
  )
}
